import type { GroupOperator } from '@/components/tree-dnd/tree-dnd-types';
import { useI18nContext } from '@/i18n/i18n-react';
import { cn } from '@/lib/utils';

interface TreeDndOperatorLabelProps {
  operator: GroupOperator;
}

export function TreeDndOperatorLabel({
  operator,
  className,
}: TreeDndOperatorLabelProps & { className?: string }) {
  const { LL } = useI18nContext();
  const label =
    operator === 'AND'
      ? LL.audiences.details.overview.filterConditions.operators.and()
      : LL.audiences.details.overview.filterConditions.operators.or();

  return (
    <span
      className={cn(
        'rounded-sm bg-secondary px-1.5 py-0.5 text-xs font-semibold uppercase tracking-wider text-secondary-foreground',
        className
      )}
    >
      {label}
    </span>
  );
}
